<template>
    <div ref="list" class="small-4 loader">
        <ul v-if="result.length > 0" class="item-list column small-4 small-up-2 large-up-3">
            <li class="item is-relative" v-for="user in result">
                <user-card :user="user"></user-card>
            </li>
        </ul>
        <!-- <p v-else class="column">Aucun résultat ne correspond à votre recherche.</p> -->
    </div>
</template>

<script>
    import {
        showLoader,
        hideLoader
    } from '../loader';

    import userCard from '../user/userCard.vue';

    export default {
        props: ['initResult'],
        components: {
            userCard
        },
        data: function () {
            return {
                result: JSON.parse(this.initResult),
            }
        },
        methods: {
            showLoader: function () {
                showLoader(this.$refs['list']);
            },
            updateResult: function (result) {
                this.result = result;
                hideLoader(this.$refs['list']);
            },
            concatResult: function (result) {
                this.result = this.result.concat(result);
                hideLoader(this.$refs['list']);
            }
        }
    }
</script>
